import React, { useEffect, useState } from 'react'
import { api } from '../../api.js'
import { Card, Field, Alert } from '../../lib.jsx'

const EMPTY_FORM = {
  name: '', price_monthly: 0, currency: 'PLN', quotas: '{}', limits: '{}',
  stripe_price_id: '', stripe_product_id: '', hidden: false,
}

function PlanForm({ initial, onDone, onCancel }) {
  const [form, setForm] = useState(initial || EMPTY_FORM)
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)
  const editing = !!initial?.id

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  const submit = async (e) => {
    e.preventDefault()
    setErr(''); setBusy(true)
    try {
      let quotas, limits
      try { quotas = JSON.parse(form.quotas || '{}') } catch { throw new Error('Quotas — niepoprawny JSON') }
      try { limits = JSON.parse(form.limits || '{}') } catch { throw new Error('Limits — niepoprawny JSON') }
      const body = {
        name: form.name, price_monthly: Number(form.price_monthly), currency: form.currency,
        quotas, limits, stripe_price_id: form.stripe_price_id || null,
        stripe_product_id: form.stripe_product_id || null, hidden: form.hidden,
      }
      if (editing) await api.patchPlan(form.id, body)
      else await api.createPlan(body)
      onDone()
    } catch (e) { setErr(e.message) } finally { setBusy(false) }
  }

  return (
    <form onSubmit={submit}>
      <Alert kind="err">{err}</Alert>
      <div className="row">
        <Field label="Nazwa"><input value={form.name} onChange={e => set('name', e.target.value)} required /></Field>
        <Field label="Cena (grosze/mies.)"><input type="number" min={0} value={form.price_monthly} onChange={e => set('price_monthly', e.target.value)} required /></Field>
        <Field label="Waluta"><input value={form.currency} onChange={e => set('currency', e.target.value)} required /></Field>
      </div>
      <div className="row">
        <Field label="Quotas (JSON)"><textarea rows={3} value={form.quotas} onChange={e => set('quotas', e.target.value)} /></Field>
        <Field label="Limits (JSON)"><textarea rows={3} value={form.limits} onChange={e => set('limits', e.target.value)} /></Field>
      </div>
      <div className="row">
        <Field label="Stripe price ID"><input value={form.stripe_price_id} onChange={e => set('stripe_price_id', e.target.value)} /></Field>
        <Field label="Stripe product ID"><input value={form.stripe_product_id} onChange={e => set('stripe_product_id', e.target.value)} /></Field>
      </div>
      <label className="check" style={{ marginBottom: 16 }}>
        <input type="checkbox" checked={form.hidden} onChange={e => set('hidden', e.target.checked)} /> Ukryty (przydzielany tylko ręcznie)
      </label>
      <div style={{ display: 'flex', gap: 10 }}>
        <button className="btn btn-primary" disabled={busy}>{busy ? 'Zapisywanie…' : (editing ? 'Zapisz zmiany' : 'Utwórz plan')}</button>
        {onCancel && <button type="button" className="btn btn-ghost" onClick={onCancel}>Anuluj</button>}
      </div>
    </form>
  )
}

export default function Plans() {
  const [plans, setPlans] = useState([])
  const [mode, setMode] = useState(null) // null | 'create' | plan.id being edited
  const [err, setErr] = useState('')

  const load = () => api.adminPlans().then(setPlans).catch(e => setErr(e.message))
  useEffect(() => { load() }, [])

  const archive = async (p) => {
    if (!window.confirm(`Zarchiwizować plan „${p.name}”?`)) return
    try { await api.archivePlan(p.id); load() } catch (e) { setErr(e.message) }
  }

  const editing = mode && mode !== 'create' ? plans.find(p => p.id === mode) : null

  return (
    <>
      <div className="topbar">
        <div><h1>Plany cenowe</h1><div className="sub">Cennik, quoty i integracja ze Stripe.</div></div>
        <button className="btn btn-primary" onClick={() => setMode(mode === 'create' ? null : 'create')}>{mode === 'create' ? 'Anuluj' : '+ Nowy plan'}</button>
      </div>
      <div className="content">
        <Alert kind="err">{err}</Alert>
        {mode === 'create' && (
          <Card title="Nowy plan"><PlanForm onDone={() => { setMode(null); load() }} onCancel={() => setMode(null)} /></Card>
        )}
        {editing && (
          <Card title={`Edycja: ${editing.name}`}>
            <PlanForm initial={{
              ...editing, quotas: JSON.stringify(editing.quotas || {}, null, 2), limits: JSON.stringify(editing.limits || {}, null, 2),
            }} onDone={() => { setMode(null); load() }} onCancel={() => setMode(null)} />
          </Card>
        )}
        <Card title="Wszystkie plany" desc={`${plans.length} łącznie`}>
          {plans.length === 0 ? <div className="empty">Brak planów — utwórz pierwszy powyżej.</div> : (
            <table>
              <thead><tr><th>Nazwa</th><th>Cena</th><th>Waluta</th><th>Aktywny</th><th>Ukryty</th><th /></tr></thead>
              <tbody>
                {plans.map(p => (
                  <tr key={p.id}>
                    <td><b>{p.name}</b></td>
                    <td>{(p.price_monthly / 100).toFixed(2)}</td>
                    <td>{p.currency}</td>
                    <td><span className={`pill ${p.active ? 'pill-done' : 'pill-canceled'}`}>{p.active ? 'tak' : 'nie'}</span></td>
                    <td>{p.hidden ? 'tak' : 'nie'}</td>
                    <td style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-sm btn-ghost" onClick={() => setMode(p.id)}>Edytuj</button>
                      {p.active && <button className="btn btn-sm btn-danger" onClick={() => archive(p)}>Archiwizuj</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Card>
      </div>
    </>
  )
}
